import React from "react";
import AddItemModal from "./AddItemModal";
import Breadcrumb from "../../../components/Breadcrumb";
import { addContractTypeDataAsync } from "../../../lib/common-service";
import { getUserCredential } from "../../../lib/cookies";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router";

const AddContractType = ({ isVisible, onClose, onSave, breadcrumbData = {} }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const cookiesData = getUserCredential();
  const fields = [
    {
      name: "contract_type_name",
      label: "Contract Type Name",
      type: "text",
      required: true,
      autoFocus: true,
      placeholder: "Enter Contract Type Name",
      errorMessage: "Contract type name is required",
    },
    {
      name: "contract_type_desc",
      label: "Description",
      type: "textarea",
      required: false,
      placeholder: "Enter Contract Type Desc.",
      rows: 3,
    },
  ];

  const initialData = {
    contract_type_name: "",
    contract_type_desc: "",
  };

  const apiConfig = {
    fieldType: "contract_type",
    endpoint: "/api/contract-types", // Future API endpoint
    method: "POST",
  };

  const handleSave = async (data) => {
    // Format data for API call
    const bodyData = {
      in_user_id: cookiesData.out_user_id,
      in_tenant_id: cookiesData.out_tenant_id,
      in_task_category_name: data.contract_type_name,
      in_task_category_desc: data.contract_type_desc || "",
      in_color_code: "#000000", // Default color
    };

    try {
      // Make API call to add contract type
      const result = await addContractTypeDataAsync(bodyData, history, dispatch);

      if (result) {
        // Create contract type object for parent component
        const newContractType = {
          text: data.contract_type_name,
          id: data.contract_type_name.toLowerCase().replace(/\s+/g, "_"),
          desc: data.contract_type_desc || "",
        };

        // Call parent onSave function
        await onSave(newContractType);
        return true; // Success
      } else {
        return false; // API call failed
      }
    } catch (error) {
      console.error("Error adding contract type:", error);
      return false; // Error occurred
    }
  };

  // Render breadcrumb if any context data is available
  const renderBreadcrumb = () => {
    const breadcrumbItems = [];

    if (breadcrumbData.division) {
      breadcrumbItems.push({
        id: "division",
        label: "Division",
        value: breadcrumbData.division,
      });
    }

    if (breadcrumbData.hospital) {
      breadcrumbItems.push({
        id: "hospital",
        label: "Hospital/Location",
        value: breadcrumbData.hospital,
      });
    }

    if (breadcrumbData.specialty) {
      breadcrumbItems.push({
        id: "specialty",
        label: "Specialty",
        value: breadcrumbData.specialty,
      });
    }

    if (breadcrumbItems.length === 0) return null;

    return <Breadcrumb items={breadcrumbItems} />;
  };

  return (
    <AddItemModal
      isVisible={isVisible}
      onClose={onClose}
      onSave={handleSave}
      title="Add Contract Type"
      fields={fields}
      initialData={initialData}
      apiConfig={apiConfig}
      breadcrumb={renderBreadcrumb()}
      modalClass="contract-type-modal"
      width={700}
    />
  );
};

export default React.memo(AddContractType);
